export default {
	STATIC: 'STATIC',
	PRIMITIVE_FIELD: 'PRIMITIVE_FIELD'
};